<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  created() {
  },
  methods: {}
}
</script>

<style lang='scss'>
@import './assets/css/base.scss';
@import './assets/css/publice.scss';

strong {
  font-weight: bold;
}

.applyInfoSaveClass {
  .el-drawer__header {
    margin-bottom: 0 !important;
  }
}

.btn_only {
  cursor: pointer;
  width: 110px;
  height: 42px;
  text-align: center;
  line-height: 42px;
  border: 1px solid;
  color: #FFF;
  font-weight: bold;
  border-radius: 4px;
  background: linear-gradient(270deg, #246ED4 0%, #3CD395 100%);
}

.btn_temp {
  cursor: pointer;
  width: 110px;
  height: 42px;
  text-align: center;
  line-height: 42px;
  color: #333;
  font-weight: bold;
  border-radius: 4px;
  border: 1px solid #99999940;
  margin-right: 50px;
}

.line-1 {
  overflow: hidden; // 超出的文本隐藏
  text-overflow: ellipsis; // 溢出用省略号显示
  white-space: nowrap; // 溢出不换行
}

.line-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.line-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body,
#app {
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
}

.nameDiv {
  color: #333;
  font-weight: 450;
  cursor: pointer;
}

.commodityReviewCont img {
  max-width: 100%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue